import { GETTASKASSIGNEELIST_SUCCESS, GETTASKASSIGNEELIST_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getAssigneeListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETTASKASSIGNEELIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETTASKASSIGNEELIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getAssigneeListReducer;
